import { Option } from 'types/types';
import Select from 'react-select';

type SelectProps = {
  options?: Option[];
  value?: any;
  onChange?: any;
  isDisabled?: boolean;
  styles?: any;
  placeholder?: string;
  disabled?: boolean;
  isMulti?: boolean;
  isClearable?: boolean;
  filterOption?: any;
  defaultValue?: any;
  isOptionDisabled?(option: Option): boolean;
};

const EpdSelectComponent: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  isDisabled,
  styles,
  placeholder,
  isMulti,
  isClearable,
  filterOption,
  defaultValue,
  ...otherProps
}) => {
  const shouldShowPlaceholder = !isDisabled && !value;

  return (
    <Select
      placeholder={shouldShowPlaceholder ? placeholder : ''}
      isDisabled={isDisabled}
      onChange={onChange}
      value={value}
      isMulti={isMulti}
      styles={styles}
      options={options}
      isClearable={isClearable}
      filterOption={filterOption}
      defaultValue={defaultValue}
      {...otherProps}
    />
  );
};

export default EpdSelectComponent;
